// extracted by mini-css-extract-plugin
export default {"container":"commercialProvider_container__U3CdP"};